var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 512 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492 160H20C8.954 160 0 168.954 0 180C0 191.046 8.954 200 20 200H492C503.046 200 512 191.046 512 180C512 168.954 503.046 160 492 160Z",
    fill: "#deb47d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M492 0H20C8.954 0 0 8.954 0 20C0 31.046 8.954 40 20 40H492C503.046 40 512 31.046 512 20C512 8.954 503.046 0 492 0Z",
    fill: "#deb47d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M492 320H20C8.954 320 0 328.954 0 340C0 351.046 8.954 360 20 360H492C503.046 360 512 351.046 512 340C512 328.954 503.046 320 492 320Z",
    fill: "#deb47d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenu);
export default __webpack_public_path__ + "static/media/MobileMenu.c4e30c9d.svg";
export { ForwardRef as ReactComponent };